/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import Modal from 'react-modal';
import { Button, Grid, TextField, List, ListItem, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector, useDispatch } from 'react-redux';
import Theme from '../ui/Theme';
import 'react-toastify/dist/ReactToastify.css';
import Add from '../../assets/AddIcon';
import SideBarListStyle from '../../styles/SideBarListStyle';
import CallButton from '../../assets/CallButton';
import PopupQuiz from '../../assets/PopupQuiz';
import Quizicon from '../../assets/QuizIcon';
import QuizIconWhite from '../../assets/QuizIconWhite';
import AudioIcon from '../../assets/AudioIcon';
import VideoIcon from '../../assets/VideoIcon';
import EmailIconBlue from '../../assets/EmailIconBlue';
import EmailIcon from '../../assets/EmailIcon';
import CallButtonWhite from '../../assets/CallButtonWhite';
import VideoIconWhite from '../../assets/VideoIconWhite';
import PopupQuizWhite from '../../assets/PopupQuizWhite';
import AudioIconWhite from '../../assets/AudioIconWhite';
import ChangeOrderCapstoneAct from './ChangeOrderCapstoneAct';
import {
  getJourneyDetails,
  showProgress,
  getCapstoneActivityDetails,
  getLevelDetails,
  getCapstoneActivityList,
  getCapstoneActivityID,
} from '../../redux/actions/DealershipActions';

import CapstoneActivityFooter from './CapstoneActivityFooter';
import service from '../../apis/service';
import { ErrorToast, MultipleErrorToast, notifySuccess } from '../utils/Utils';
import { UploadFolderButton } from './UploadButton';
import { apiEndpoints } from '../../constants/apiEndpoints';
import QuillRichTextEditor from '../common/QuillRichTextEditor';
const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flexStart',
    padding: '0px',
    position: 'static',
    width: '279px',
    height: '38px',
    left: '0px',
    marginTop: '24px',
    /* Container BG 1 (light) */
    border: `3px solid ${Theme.palette.secondary.main}`,
  },
  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
  },
  popupSubHeading: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    marginTop: 0,
    // marginBottom: "35px",
  },
  input: {
    width: '216px',
    height: '37px',
    left: '20px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '0px',
    /* or 0% */
    display: 'flex',
    alignItems: 'center',
    /* Brand */
    color: Theme.palette.primary.main,
  },
  addIcon: {
    width: '14px',
    height: '14px',
  },
  title: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '20px',
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    padding: '16px 16px 16px 12px',
    /* Absolute (dark) */
    color: 'black',
    width: '100%',
  },
  description: {
    padding: '12px 12px 24px 12px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    /* or 175% */
    display: 'flex',
    alignItems: 'center',
    /* Absolute (dark) */
    color: 'black',
  },
  activityLink: {
    padding: '15.5px 0 0 12px ',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '17px',
  },
  popupLabels: {
    marginLeft: '30px',
    marginTop: '24px',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    textAlign: 'left',
    // marginLeft: "18px",
  },
  buttonText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '15px',
  },
  quizButton: {
    padding: '0px 4px',
    marginRight: '10px',
    width: '99px',
    height: '40px',
    background: Theme.palette.secondary.main,
    color: Theme.palette.primary.main,
    '&:hover': {
      background: Theme.palette.primary.main,
      color: '#fff',
    },
  },
  quizButtonSelected: {
    padding: '0px 4px',
    marginRight: '10px',
    width: '99px',
    height: '40px',
    background: Theme.palette.primary.main,
    color: '#FFF',
    '&:hover': {
      background: Theme.palette.primary.main,
      color: '#fff',
    },
  },
  emailButton: {
    padding: '0px 4px',
    marginRight: '10px',
    width: '105px',
    height: '40px',
    background: Theme.palette.secondary.main,
    color: Theme.palette.primary.main,
    '&:hover': {
      background: Theme.palette.primary.main,
      color: '#fff',
    },
  },
  emailButtonSelected: {
    padding: '0px 4px',
    marginRight: '10px',
    width: '105px',
    height: '40px',
    background: Theme.palette.primary.main,
    color: '#FFF',
    '&:hover': {
      background: Theme.palette.primary.main,
      color: '#fff',
    },
  },
  callButton: {
    padding: '0px 4px',
    marginRight: '10px',
    width: '93px',
    height: '40px',
    background: Theme.palette.secondary.main,
    color: Theme.palette.primary.main,
    '&:hover': {
      background: Theme.palette.primary.main,
      color: '#fff',
    },
  },
  callButtonSelected: {
    padding: '0px 4px',
    marginRight: '10px',
    width: '93px',
    height: '40px',
    background: Theme.palette.primary.main,
    color: '#FFF',
    '&:hover': {
      background: Theme.palette.primary.main,
      color: '#fff',
    },
  },
  audioButton: {
    padding: '0px 4px',
    marginRight: '10px',
    width: '174px',
    height: '40px',
    background: Theme.palette.secondary.main,
    color: Theme.palette.primary.main,
    '&:hover': {
      background: Theme.palette.primary.main,
      color: '#fff',
    },
  },
  audioButtonSelected: {
    padding: '0px 4px',
    marginRight: '10px',
    width: '174px',
    height: '40px',
    background: Theme.palette.primary.main,
    color: '#FFF',
    '&:hover': {
      background: Theme.palette.primary.main,
      color: '#fff',
    },
  },
  popupquizButton: {
    padding: '0px 4px',
    marginRight: '10px',
    width: '144px',
    height: '40px',
    background: Theme.palette.secondary.main,
    color: Theme.palette.primary.main,
    '&:hover': {
      background: Theme.palette.primary.main,
      color: '#fff',
    },
  },
  popupquizButtonSelected: {
    padding: '0px 4px',
    marginRight: '10px',
    width: '144px',
    height: '40px',
    background: Theme.palette.primary.main,
    color: '#FFF',
    '&:hover': {
      background: Theme.palette.primary.main,
      color: '#fff',
    },
  },
  resize4: {
    backgroundColor: Theme.palette.secondary.main,
    height: '41px',
    width: '395px',
    padding: '5px 10px',
    marginLeft: '30px',
    marginTop: '10px',
    marginBottom: '20px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    color: 'black',
  },
}));

export const CapstoneActivityPopup = (props) => {
  const classes = useStyles();
  const classesList = SideBarListStyle();
  const dispatch = useDispatch();
  const [addNew, setAddNew] = useState(1);
  const [quizHover, setQuizHover] = useState(0);
  const [emailHover, setEmailHover] = useState(0);
  const [callHover, setCallHover] = useState(0);
  const [videoHover, setVideoHover] = useState(0);
  const [audioHover, setAudioHover] = useState(0);
  const [popQuizHover, setPopQuizHover] = useState(0);
  const [showChangeOrderCapstoneAct, setShowChangeOrderCapstoneAct] = useState(false);
  const [viewJourneyPop, setViewJourneyPop] = useState(props.open);
  const [activityTitle, setActivityTitle] = useState('');
  const [capstoneActivityTypeId, setcapstoneActivityTypeId] = useState('');
  const [activityDescription, setActivityDescription] = useState('');
  const [activityLmsUrl, setActivityLmsUrl] = useState('');
  const [instDescription, setInstDescription] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(1);

  const levelId = useSelector((state) => state.getSelectedLevelID);
  const capstoneList = useSelector((state) => state.getCapstoneActivityList);
  const capstoneActID = useSelector((state) => state.getCapstoneActivityID);
  const capstoneDetails = useSelector((state) => state.getCapstoneDetails.capstonedetails);
  const journeyDetails = useSelector((state) => state.JourneyDetails.journeydetails);

  React.useEffect(() => {
    setActivityTitle('');
    setcapstoneActivityTypeId('');
    setActivityDescription('');
    setActivityLmsUrl('');
    setInstDescription('');
    handleListItemClick(0, capstoneActID);
  }, [capstoneActID]);
  React.useEffect(() => {
    if (capstoneList !== undefined) {
      if (capstoneList.capstoneactivitylist.length > 0) {
        if (capstoneList.capstoneactivitylist[0].id !== null) {
          setAddNew(0);
          handleListItemClick(0, capstoneList.capstoneactivitylist[0].id);
        }
      }
    }
  }, [capstoneList]);

  const handleActivityTitleChange = (e) => {
    setActivityTitle(e.target.value);
  };
  const handleActivityTypeId = (e) => {
    if (e.currentTarget.id === 'video') {
      setcapstoneActivityTypeId(1);
    } else if (e.currentTarget.id === 'email') {
      setcapstoneActivityTypeId(2);
    } else if (e.currentTarget.id === 'url') {
      setcapstoneActivityTypeId(3);
    } else if (e.currentTarget.id === 'call') {
      setcapstoneActivityTypeId(4);
    } else if (e.currentTarget.id === 'popquiz') {
      setcapstoneActivityTypeId(5);
    } else if (e.currentTarget.id === 'audio') {
      setcapstoneActivityTypeId(6);
    }
  };
  const handleOpenChangeOrderCapstoneAct = () => {
    setShowChangeOrderCapstoneAct(true);
  };
  const handleCloseChangeOrderCapstoneAct = () => {
    setShowChangeOrderCapstoneAct(false);
  };
  const handleActivityLmsUrlChange = (e) => {
    setActivityLmsUrl(e.target.value);
  };

  const handleActivityDescriptionChange = (e) => {
    setActivityDescription(e.target.value);
  };
  const handleActivityInstDescriptionChange = (e) => {
    setInstDescription(e);
  };
  const validateForm = () => {
    const errors = [];
    let formIsValid = true;
    if (!activityTitle) {
      formIsValid = false;
      errors.push('Please enter activity title.');
    }
    if (!activityDescription) {
      formIsValid = false;
      errors.push('Please enter activity goals.');
    }
    if (!activityLmsUrl) {
      if (capstoneActivityTypeId !== 2 && capstoneActivityTypeId !== 1) {
        formIsValid = false;
        errors.push('Please enter URL.');
      }
    }
    if (!instDescription) {
      if (capstoneActivityTypeId === 2 || capstoneActivityTypeId === 1) {
        formIsValid = false;
        errors.push('Please enter instruction.');
      }
    }
    if (capstoneActivityTypeId === '') {
      formIsValid = false;
      errors.push('Please enter capstone activity type.');
    }

    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return formIsValid;
  };
  const handleAddNew = () => {
    setAddNew(1);
    dispatch(showProgress(true));
    setActivityTitle('');
    setcapstoneActivityTypeId('');
    setActivityDescription('');
    setActivityLmsUrl('');
    setInstDescription('');

    dispatch(showProgress(false));
  };
  const closePopup = () => {
    setViewJourneyPop(false);
    props.close();
  };
  const deleteCap = async () => {
    await service
      .delete(apiEndpoints.JOURNEY_CAPSTONE_ACTIVITY_BY_ID.replace('CAP_ACT_ID', capstoneActID))
      .then(async () => {
        setActivityTitle('');
        setcapstoneActivityTypeId('2');
        setActivityDescription('');
        setActivityLmsUrl('');
        setInstDescription('');
        dispatch(getLevelDetails('capstoneActCountDec', 1));
        // Fetch updated journey details from API
        if (journeyDetails?.id) {
          const journeyResponse = await service.get(apiEndpoints.JOURNEY_BY_ID.replace('ID', journeyDetails.id), '');
          dispatch(getJourneyDetails('updateJourneyDetails', journeyResponse));
        }
        dispatch(getCapstoneActivityDetails([]));
        dispatch(getCapstoneActivityList('delete', capstoneActID));
        notifySuccess('Deleted Successfully');
      })
      .catch((error) => {
        console.log(error);
        ErrorToast(error);
      });
  };
  const onsubmit = async () => {
    const check = validateForm();
    if (check) {
      let data = '';
      if (addNew === 0 && capstoneList.capstoneactivitylist.length > 0) {
        dispatch(showProgress(true));

        if (capstoneActivityTypeId === 2 || capstoneActivityTypeId === 1) {
          data = JSON.stringify({
            levelId,
            capstoneActivityTypeId,
            title: activityTitle,
            subTitle: activityTitle,
            description: activityDescription,
            instructions: JSON.stringify({ detail: instDescription }),
          });
        } else {
          data = JSON.stringify({
            levelId,
            capstoneActivityTypeId,
            title: activityTitle,
            subTitle: activityTitle,
            description: activityDescription,
            externalUrl: activityLmsUrl,
            instructions: JSON.stringify({}),
          });
        }

        await service
          .put(apiEndpoints.JOURNEY_CAPSTONE_ACTIVITY_BY_ID.replace('CAP_ACT_ID', selectedIndex), data)
          .then(() => {
            dispatch(showProgress(false));
            closePopup();
            notifySuccess('Completed Successfully');
          })
          .catch((error) => {
            console.log(error);
            ErrorToast(error);
            dispatch(showProgress(false));
            closePopup();
          });
      } else {
        dispatch(showProgress(true));
        if (capstoneActivityTypeId === 2 || capstoneActivityTypeId === 1) {
          data = JSON.stringify({
            levelId,
            capstoneActivityTypeId,
            title: activityTitle,
            subTitle: activityTitle,
            description: activityDescription,
            instructions: JSON.stringify({ detail: instDescription }),
          });
        } else {
          data = JSON.stringify({
            levelId,
            capstoneActivityTypeId,
            title: activityTitle,
            subTitle: activityTitle,
            description: activityDescription,
            externalUrl: activityLmsUrl,
            instructions: JSON.stringify({}),
          });
        }

        await service
          .post(apiEndpoints.JOURNEY_CAPSTONE_ACTIVITY, data)
          .then(async (response) => {
            dispatch(getLevelDetails('capstoneActCount', 1));
            // Fetch updated journey details from API
            if (journeyDetails?.id) {
              const journeyResponse = await service.get(
                apiEndpoints.JOURNEY_BY_ID.replace('ID', journeyDetails.id),
                '',
              );
              dispatch(getJourneyDetails('updateJourneyDetails', journeyResponse));
            }
            capstoneList.capstoneactivitylist.push({
              id: response.id,
              title: response.title,
              type: response.capstoneActivityTypeId === 1 ? 'video' : ' ',
            });
            dispatch(getCapstoneActivityList('update', capstoneList.capstoneactivitylist));
            dispatch(showProgress(false));
            notifySuccess('Completed Successfully');
            handleListItemClick(0, response.id);
          })
          .catch((error) => {
            ErrorToast(error);
            dispatch(showProgress(false));
          });
      }
    }
  };
  const handleListItemClick = async (event, index) => {
    setAddNew(0);
    setSelectedIndex(index);
    dispatch(getCapstoneActivityID(index));
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.JOURNEY_CAPSTONE_ACTIVITY_BY_ID.replace('CAP_ACT_ID', index), '')
      .then((response) => {
        const val = JSON.parse(response.instructions).detail;

        dispatch(getCapstoneActivityDetails(response));
        setActivityTitle(response.title);
        setcapstoneActivityTypeId(response.capstoneActivityTypeId);
        setActivityDescription(response.description);
        setActivityLmsUrl(response.externalUrl);
        setInstDescription(val);
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(getCapstoneActivityDetails([]));
        setActivityTitle('');
        setcapstoneActivityTypeId('');
        setActivityDescription('');
        setActivityLmsUrl('');
        setInstDescription('');
        dispatch(showProgress(false));
      });
  };
  const getListItem = () => {
    if (capstoneList !== undefined) {
      if (capstoneList.capstoneactivitylist.length > 0) {
        return capstoneList.capstoneactivitylist.map((data) => {
          const index = data.id;
          return (
            <div key={data.id} className={selectedIndex === index ? classesList.highlightItem : ''}>
              <ListItem
                key={data.id}
                button
                selected={selectedIndex === index}
                className={classesList.listStyling}
                onClick={(event) => handleListItemClick(event, index)}
              >
                <ListItemText
                  primary={
                    <div>
                      <p
                        className={`
              ${selectedIndex === index ? classesList.listTextSelected : classesList.listTextNonSelected}
            `}
                      >
                        {data.title}
                      </p>
                    </div>
                  }
                  secondary={
                    <div>
                      <div
                        className={
                          selectedIndex === index ? classesList.listSubTextSelected : classesList.listSubTextNonSelected
                        }
                      >
                        {data.type}
                      </div>
                    </div>
                  }
                />
              </ListItem>
            </div>
          );
        });
      }
      return [];
    }
    return [];
  };

  return (
    <Modal
      isOpen={viewJourneyPop}
      onRequestClose={() => false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'hsla(50, 33%, 25%, 0.35)',
        },
        content: {
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          border: 0,
          height: '83%',
          width: '60%',
          overflow: 'hidden',
        },
      }}
    >
      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start">
        <Grid item xs={11}>
          <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start">
            <Grid item className={classes.popupHeading}>
              {capstoneDetails ? capstoneDetails.description : ''}
            </Grid>
            <Grid item className={classes.popupSubHeading}>
              {journeyDetails ? journeyDetails.title : ''}
            </Grid>
          </Grid>
        </Grid>
        <Grid itemxs={1}>
          <CloseIcon className={classes.popupCloseBtn} style={{ cursor: 'pointer' }} onClick={closePopup} />
        </Grid>
      </Grid>
      <Grid container direction="row" style={{ height: 'auto' }} justifyContent="center" alignItems="flex-start">
        <Grid item xs={4}>
          <Grid
            container
            direction="row"
            className={classes.root}
            style={{ height: '100%', width: '100%', cursor: 'pointer' }}
            justifyContent="space-evenly"
            alignItems="center"
            onClick={handleAddNew}
          >
            <Grid item className={classes.input}>
              Add Activity
            </Grid>
            <Grid item className={classes.addIcon}>
              <Add />
            </Grid>
          </Grid>
          <List
            component="nav"
            aria-label="secondary mailbox folder"
            style={{
              height: 'auto',
              maxHeight: '63vh',
              overflowY: 'auto',
            }}
          >
            {getListItem()}
          </List>
        </Grid>
        <Grid item xs={8}>
          <div
            style={{
              background: Theme.palette.ternary.main,
              width: '100%',
              marginTop: '24px',
              height: '100vh',
              maxHeight: '77vh',
              overflowY: 'scroll',
            }}
          >
            <Grid container direction="column" style={{ width: '100%' }}>
              <Grid item>
                <div className={classes.popupLabels}>
                  <label htmlFor="guideOverview">Activity Title</label>
                </div>
              </Grid>
              <Grid
                item
                style={{
                  width: '90%',
                  height: '66px',
                  marginLeft: '4.8%',
                  marginRight: '4.8%',
                  marginTop: '24px',
                  background: '#FFFFFF',
                }}
              >
                <TextField
                  id="activityTitleId"
                  name="activityTitle"
                  required
                  autoFocus
                  autoComplete="off"
                  width="100%"
                  autoSave="off"
                  onChange={handleActivityTitleChange}
                  placeholder="Enter activity title here"
                  multiline
                  InputProps={{
                    disableUnderline: true,

                    classes: {
                      input: classes.title,
                    },
                  }}
                  value={activityTitle}
                  rows={1}
                />
              </Grid>
              <Grid item>
                <div className={classes.popupLabels}>
                  <label htmlFor="guideOverview">Activity Goal</label>
                </div>
              </Grid>
              <Grid
                item
                style={{
                  height: '6%',

                  marginLeft: '4.8%',
                  marginRight: '4.8%',
                  marginTop: '12px',
                  background: '#FFFFFF',

                  width: '90%',
                }}
              >
                <TextField
                  id="activityTitleId"
                  name="activityTitle"
                  required
                  autoComplete="off"
                  autoSave="off"
                  onChange={handleActivityDescriptionChange}
                  placeholder="Enter activity goal here"
                  multiline
                  InputProps={{
                    disableUnderline: true,

                    classes: {
                      input: classes.description,
                    },
                  }}
                  value={activityDescription}
                  rows={2}
                />
              </Grid>
              <Grid item>
                <div className={classes.popupLabels}>
                  <label htmlFor="guideOverview">Type of activity</label>
                </div>
              </Grid>
              <Grid item>
                <Grid container direction="row" style={{ marginLeft: '24px', marginTop: '12px' }}>
                  <Grid item>
                    <Button
                      className={capstoneActivityTypeId === 3 ? classes.quizButtonSelected : classes.quizButton}
                      onMouseEnter={() => {
                        setQuizHover(1);
                      }}
                      onMouseLeave={() => {
                        setQuizHover(0);
                      }}
                      variant="text"
                      id="url"
                      onClick={handleActivityTypeId}
                      startIcon={quizHover === 1 || capstoneActivityTypeId === 3 ? <QuizIconWhite /> : <Quizicon />}
                    >
                      <div className={classes.buttonText}>Quiz</div>
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      className={capstoneActivityTypeId === 2 ? classes.emailButtonSelected : classes.emailButton}
                      onMouseEnter={() => {
                        setEmailHover(1);
                      }}
                      onMouseLeave={() => {
                        setEmailHover(0);
                      }}
                      variant="text"
                      id="email"
                      onClick={handleActivityTypeId}
                      startIcon={emailHover === 1 || capstoneActivityTypeId === 2 ? <EmailIcon /> : <EmailIconBlue />}
                    >
                      <div className={classes.buttonText}>Email</div>
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      className={capstoneActivityTypeId === 4 ? classes.callButtonSelected : classes.callButton}
                      onMouseEnter={() => {
                        setCallHover(1);
                      }}
                      onMouseLeave={() => {
                        setCallHover(0);
                      }}
                      variant="text"
                      id="call"
                      onClick={handleActivityTypeId}
                      startIcon={callHover === 1 || capstoneActivityTypeId === 4 ? <CallButtonWhite /> : <CallButton />}
                    >
                      <div className={classes.buttonText}>Call</div>
                    </Button>
                  </Grid>
                </Grid>
                <Grid container direction="row" style={{ marginLeft: '24px', marginTop: '12px' }}>
                  <Grid item>
                    <Button
                      className={capstoneActivityTypeId === 6 ? classes.audioButtonSelected : classes.audioButton}
                      onMouseEnter={() => {
                        setAudioHover(1);
                      }}
                      onMouseLeave={() => {
                        setAudioHover(0);
                      }}
                      variant="text"
                      id="audio"
                      onClick={handleActivityTypeId}
                      startIcon={audioHover === 1 || capstoneActivityTypeId === 6 ? <AudioIconWhite /> : <AudioIcon />}
                    >
                      <div className={classes.buttonText}> Audio Recording</div>
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      className={capstoneActivityTypeId === 1 ? classes.audioButtonSelected : classes.audioButton}
                      id="video"
                      onMouseEnter={() => {
                        setVideoHover(1);
                      }}
                      onClick={handleActivityTypeId}
                      onMouseLeave={() => {
                        setVideoHover(0);
                      }}
                      variant="text"
                      startIcon={videoHover === 1 || capstoneActivityTypeId === 1 ? <VideoIconWhite /> : <VideoIcon />}
                    >
                      <div className={classes.buttonText}>Video Recording</div>
                    </Button>
                  </Grid>
                </Grid>
                <Grid container direction="row" style={{ marginLeft: '24px', marginTop: '12px' }}>
                  <Grid item>
                    <Button
                      id="popquiz"
                      className={
                        capstoneActivityTypeId === 5 ? classes.popupquizButtonSelected : classes.popupquizButton
                      }
                      onMouseEnter={() => {
                        setPopQuizHover(1);
                      }}
                      onMouseLeave={() => {
                        setPopQuizHover(0);
                      }}
                      variant="text"
                      onClick={handleActivityTypeId}
                      startIcon={
                        popQuizHover === 1 || capstoneActivityTypeId === 5 ? <PopupQuizWhite /> : <PopupQuiz />
                      }
                    >
                      <div className={classes.buttonText}>Pop up quiz</div>
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              {capstoneActivityTypeId !== 2 && capstoneActivityTypeId !== 1 && (
                <div>
                  <Grid item>
                    <div className={classes.popupLabels}>
                      <label htmlFor="upload_s3_interaction">Upload interaction to s3</label>
                    </div>
                    <Grid
                      container
                      direction="column"
                      justifyContent="center"
                      alignItems="flex-end"
                      className={classes.resize4}
                      style={{ marginBottom: '20px' }}
                    >
                      <Grid item>
                        <UploadFolderButton
                          name="upload_s3_interaction"
                          urlValue={activityLmsUrl}
                          setUrlValue={setActivityLmsUrl}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <div className={classes.popupLabels}>
                      <label htmlFor="guideOverview">Activity Link</label>
                    </div>
                  </Grid>
                  <Grid
                    item
                    style={{
                      height: '66px',
                      marginLeft: '4.8%',
                      marginRight: '4.8%',
                      marginTop: '12px',
                      background: '#FFFFFF',
                    }}
                  >
                    <TextField
                      id="activityLmsUrlId"
                      name="activityLmsUrl"
                      required
                      autoComplete="off"
                      width="100%"
                      autoSave="off"
                      onChange={handleActivityLmsUrlChange}
                      placeholder="Enter LMS URL here"
                      multiline
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: classes.activityLink,
                        },
                      }}
                      value={activityLmsUrl}
                      rows={1}
                    />
                  </Grid>
                </div>
              )}
              {capstoneActivityTypeId === 1 || capstoneActivityTypeId === 2 ? (
                <div>
                  <Grid item>
                    <div className={classes.popupLabels}>
                      <label htmlFor="guideOverview">Instruction</label>
                    </div>
                  </Grid>
                  <Grid
                    item
                    style={{
                      width: '95%',
                      marginTop: '12px',
                      marginLeft: '24px',
                    }}
                  >
                    <QuillRichTextEditor value={instDescription} changeFn={handleActivityInstDescriptionChange} />
                  </Grid>
                </div>
              ) : (
                <div></div>
              )}
              <CapstoneActivityFooter
                clickFn={onsubmit}
                delFn={deleteCap}
                add={addNew}
                leng={capstoneList.capstoneactivitylist.length}
                change={handleOpenChangeOrderCapstoneAct}
              />
            </Grid>
          </div>
        </Grid>
      </Grid>
      {showChangeOrderCapstoneAct && <ChangeOrderCapstoneAct open close={handleCloseChangeOrderCapstoneAct} />}
    </Modal>
  );
};
